import React, { Component } from "react";
import Wraaper from "../../components/Wrapper";
import Logo from "../../components/Logo";
import Section from "../../components/Section";
import month from "../../controllers/month.json";
import {
  Button,
  CircularProgress,
  FormControlLabel,
  MenuItem,
  Radio,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { notification, priceNumbers, setTitle } from "../../controllers";
import moment from "jalali-moment";
import cloneDeep from "lodash/cloneDeep";
import axios from "../../boot/axios";
import "./index.css";
import Wrapper from "../../components/Wrapper";

const title =
  "محاسبه آنلاین خسارت تاخیر تادیه چک ، سفته ، دین ، مطالبات و ... بر اساس شاخص بانک مرکزی";

class KhesaratTakhirTadieh extends Component {
  constructor() {
    super();
    this.calculations = ["ماهانه", "سالانه"];
    this.indicators = [
      { name: "سر رسید", state: "dueDate" },
      { name: "پرداخت", state: "payment" },
    ];
    this.state = {
      calculationType: 0,
      demand: {
        value: 0,
        showValue: "",
      },
      indicators: {
        dueDate: {
          year: 1399,
          month: 1,
          value: -1,
        },
        payment: {
          year: 1399,
          month: 1,
          value: -1,
        },
      },
      calculations: [],
    };
  }

  getThisDate = (format = "YYYY/MM/DD") => {
    const dateNow = new Date().getTime();
    const thisYear = moment(dateNow).locale("fa").format(format);
    return thisYear;
  };

  yearsValue = () => {
    const minYear = 1315;
    const maxYear = this.getThisDate("YYYY");
    let years = [];
    for (let i = minYear; i <= maxYear; i++) {
      years.unshift(i);
    }
    return years;
  };

  getIndex = async (type) => {
    const { indicators, calculationType } = this.state;
    let data = {
      year: indicators[type].year,
      month: indicators[type].month,
      type: calculationType,
    };
    await this.setIndex(type, -1);
    axios
      .post("KhesareatTakhir/Shakhes", data)
      .then(({ data }) => {
        this.setIndex(type, data.value);
      })
      .catch(({ response }) => {
        this.setIndex(type, null);
        this.handleErrors(response);
      });
  };

  setIndex = (type, value) => {
    const { indicators } = cloneDeep(this.state);
    indicators[type].value = value;
    this.setState({ indicators });
  };

  setIndicatorsBasedYearCalculation = () => {
    const { indicators } = cloneDeep(this.state);
    Object.keys(indicators).forEach((indicator) => {
      indicators[indicator].month = 0;
    });
    this.setState({ indicators });
  };

  checkIndicatorsCondition = (prevState, type) => {
    const { indicators, calculationType } = cloneDeep(this.state);
    const indicatorCondition_1 =
      JSON.stringify(prevState.indicators[type].year) !==
      JSON.stringify(indicators[type].year);
    const indicatorCondition_2 =
      JSON.stringify(prevState.indicators[type].month) !==
      JSON.stringify(indicators[type].month);
    const indicatorCondition_3 = indicators[type].year !== 0;
    const indicatorCondition_4 =
      calculationType === 0 ? indicators[type].month !== 0 : true;
    const indicatorConditions =
      (indicatorCondition_1 || indicatorCondition_2) &&
      indicatorCondition_3 &&
      indicatorCondition_4;
    return indicatorConditions;
  };

  checkDemand = () => {
    const { demand } = this.state;
    if (demand.value === 0) {
      notification({ text: "میزان طلب را دقیق وارد کنید." });
      return false;
    }
    return true;
  };

  checkIndicators = () => {
    const { indicators, calculationType } = this.state;

    const checkIndicatorsYears =
      indicators.dueDate.year > indicators.payment.year;

    const checkIndicatorsMonth =
      indicators.dueDate.year === indicators.payment.year &&
      indicators.dueDate.month > indicators.payment.month;

    const checkIndicatorsValue =
      indicators.dueDate.value === null || indicators.payment.value === null;

    if (checkIndicatorsYears) {
      notification({
        text: "سال سر رسید نباید بالاتر از سال مطالبه باشد.",
      });
    }else if (checkIndicatorsMonth && calculationType === 0) {
      notification({
        text: "ماه سر رسید نباید بالاتر از ماه مطالبه باشد.",
      });
    }else if (checkIndicatorsValue) {
      notification({ text: "شاخص مورد نظر تعریف نشده است." });
    }

    switch (calculationType) {
      case 0:
        return (
          !checkIndicatorsYears &&
          !checkIndicatorsMonth &&
          !checkIndicatorsValue
        );
      case 1:
        return !checkIndicatorsYears && !checkIndicatorsValue;
      default:
        break;
    }
  };

  handleErrors = (response) => {
    const status = response.status;
    const text = (data = {}) =>
      `شاخص 
      ${month[data.month - 1]}
      ${data.year}
       ثبت نشده است.در صورتیکه شاخص اعلام شده است و از آن اطلاع دارید جهت ثبت و استفاده سایرین لطفاً شاخص ماه و سال مورد نظر را به شماره 
       ${data.phoneNumber}
        ارسال کنید`;
    if (status === 400) {
      const errors = response.data;
      notification({ text: text(errors), duration: 15000 });
    }
  };

  calculation = () => {
    const { demand, calculationType, indicators, calculations } = this.state;
    const data = {
      mizanTalab: demand.value,
      type: calculationType,
      yearSarresid: indicators.dueDate.year,
      monthSarresid: calculationType === 0 ? indicators.dueDate.month : 0,
      yearPardakht: indicators.payment.year,
      monthPardakht: calculationType === 0 ? indicators.payment.month : 0,
    };
    if (this.checkDemand() && this.checkIndicators()) {
      axios.post("KhesareatTakhir/Mohasebe", data).then(({ data }) => {
        this.setState({ calculations: [...calculations, data] });
      });
    }
  };

  totalCalculations = () => {
    const { calculations } = this.state;
    let total = {
      khesaratAsletalab: 0,
      khesaratarzeshafzodeh: 0,
      total: 0,
    };
    calculations.forEach((item) => {
      total.khesaratAsletalab += item.khesaratAsletalab;
      total.khesaratarzeshafzodeh += item.khesaratarzeshafzodeh;
      total.total += item.khesaratAsletalab + item.khesaratarzeshafzodeh;
    });
    return total;
  };

  print = () => {
    const { calculations } = this.state;
    if (calculations.length > 0) {
      window.print();
    } else {
      notification({ text: "موردی برای چاپ وجود ندارد." });
    }
  };

  componentDidMount() {
    setTitle(title);
    this.getIndex("dueDate");
    this.getIndex("payment");
  }

  componentDidUpdate(prevProps, prevState) {
    const { indicators, calculationType } = cloneDeep(this.state);
    // due date conditions
    if (this.checkIndicatorsCondition(prevState, "dueDate")) {
      this.getIndex("dueDate");
    }
    // payment conditions
    if (this.checkIndicatorsCondition(prevState, "payment")) {
      this.getIndex("payment");
    }
    if (prevState.calculationType !== calculationType) {
      // this.setIndicatorsBasedYearCalculation()
      this.getIndex("dueDate").then(() => {
        this.getIndex("payment");
      });
    }
  }

  render() {
    const { calculationType, demand, indicators, calculations } = cloneDeep(
      this.state
    );
    return (
      <Wraaper>
        <div className="KhesaratTakhirTadieh mx-auto pt-3">
          <Logo pageName={title} />
          <header className="flex flex-center mb-3">
            <Section title="محاسبه">
              {this.calculations.map((item, index) => (
                <FormControlLabel
                  key={index}
                  className="mx-2"
                  control={
                    <Radio
                      checked={calculationType === index}
                      value={index}
                      onChange={() => {
                        this.setState({ calculationType: index });
                      }}
                      color="primary"
                    />
                  }
                  label={item}
                  labelPlacement="end"
                />
              ))}
            </Section>
          </header>
          <div className="demand flex column flex-center my-2">
            <Typography component="p" className="mb-2">
              میزان طلب را وارد نمایید
            </Typography>
            <TextField
              dir="ltr"
              required
              variant="outlined"
              value={demand.showValue}
              onChange={(e) => {
                const value = e.target.value;
                demand.value = Number(priceNumbers(value).replace(/,/g, ""));
                demand.showValue = priceNumbers(value);
                this.setState({ demand });
              }}
              InputProps={{
                startAdornment: (
                  <Typography component="span" className="mx-2">
                    ريال
                  </Typography>
                ),
              }}
            />
          </div>
          <div className="indicators flex px-5 mt-4 mx-auto full-width">
            {this.indicators.map((item, index) => (
              <Section key={index} title={`سال و ماه ${item.name} و شاخص آن`}>
                <div className="flex column flex-center">
                  <div className="flex flex-center full-width">
                    <span className="title">سال</span>
                    <Select
                      className="flex-1"
                      variant="outlined"
                      defaultValue=""
                      value={indicators[item.state].year}
                      onChange={(e) => {
                        const value = e.target.value;
                        indicators[item.state].year = value;
                        this.setState({ indicators });
                      }}
                    >
                      {this.yearsValue().map((item, index) => (
                        <MenuItem key={index} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <div className="flex flex-center full-width">
                    <span className="title">ماه</span>
                    <Select
                      className="flex-1"
                      disabled={calculationType === 1}
                      variant="outlined"
                      defaultValue=""
                      value={indicators[item.state].month}
                      onChange={(e) => {
                        const value = e.target.value;
                        indicators[item.state].month = value;
                        this.setState({ indicators });
                      }}
                    >
                      {month.map((item, index) => (
                        <MenuItem key={index} value={index + 1}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <div className="flex flex-center full-width">
                    <span className="title">شاخص</span>
                    <div dir="ltr" className="flex-1 indicator">
                      {indicators[item.state].value === -1 ? (
                        <CircularProgress size="20px" />
                      ) : (
                        indicators[item.state].value
                      )}
                    </div>
                  </div>
                </div>
              </Section>
            ))}
          </div>
          <div className="btns my-4 flex flex-center">
            <Button
              variant="contained"
              color="primary"
              onClick={this.calculation}
            >
              محاسبه
            </Button>
            <Button variant="contained" color="primary" onClick={this.print}>
              چاپ
            </Button>
          </div>
          {calculations.length > 0 ? (
            <Wrapper>
              <div className="calculations my-4 mx-auto">
                <table>
                  <thead>
                    <tr>
                      <th>ردیف</th>
                      <th>تاریخ مطالبه</th>
                      <th>شاخص</th>
                      <th>تاریخ پرداخت</th>
                      <th>شاخص</th>
                      <th>اصل طلب</th>
                      <th>ارزش افزوده</th>
                      <th>جمع ارزش افزوده و اصل طلب (ريال)</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {calculations.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{`${
                          item.monthSarresid === 0
                            ? "سال"
                            : month[item.monthSarresid - 1]
                        } ${item.yearSarresid}`}</td>
                        <td>{item.shakesSarresid}</td>
                        <td>{`${
                          item.monthPardakht === 0
                            ? "سال"
                            : month[item.monthPardakht - 1]
                        } ${item.yearPardakht}`}</td>
                        <td>{item.shakesPardakht}</td>
                        <td>{item.khesaratAsletalab.toLocaleString()}</td>
                        <td>{item.khesaratarzeshafzodeh.toLocaleString()}</td>
                        <td>
                          {(
                            item.khesaratAsletalab + item.khesaratarzeshafzodeh
                          ).toLocaleString()}
                        </td>
                        <td>
                          <div className="btns flex flex-center mx-auto">
                            <Button
                              variant="outlined"
                              color="secondary"
                              onClick={() => {
                                calculations.splice(index, 1);
                                this.setState({ calculations });
                              }}
                            >
                              حذف
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {calculations.length > 1 ? (
                      <tr className="total">
                        <td>-</td>
                        <td>جمع کل</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>
                          {this.totalCalculations().khesaratAsletalab.toLocaleString()}
                        </td>
                        <td>
                          {this.totalCalculations().khesaratarzeshafzodeh.toLocaleString()}
                        </td>
                        <td>
                          {this.totalCalculations().total.toLocaleString()}
                        </td>
                        <td>-</td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
              <Button
                className="new-calculation my-4 mx-auto"
                variant="text"
                color="primary"
                onClick={() => {
                  this.setState({ calculations: [] });
                }}
              >
                محاسبه جدید
              </Button>
            </Wrapper>
          ) : null}
        </div>
      </Wraaper>
    );
  }
}

export default KhesaratTakhirTadieh;
